/* The four platform pages (UX-11): title, notices, content, on the mockup's 16px rhythm. */
.page {
  display: flex;
  flex-direction: column;
}

.content {
  display: flex;
  flex-direction: column;
  gap: var(--space-4);
  min-width: 0;
}
